export function getChestIconPath(type) {
  return `/img/chests/${type}.jpg`;
}
